
export const brazilianCities = [
  "São Paulo, SP",
  "Rio de Janeiro, RJ",
  "Brasília, DF",
  "Goiânia, GO",
  "Belo Horizonte, MG",
  "Salvador, BA",
  "Fortaleza, CE",
  "Recife, PE",
  "Curitiba, PR",
  "Porto Alegre, RS",
  "Manaus, AM",
  "Belém, PA",
  "Florianópolis, SC",
  "Campinas, SP",
  "Vitória, ES",
  "Natal, RN",
  "Campo Grande, MS",
  "Cuiabá, MT",
  "João Pessoa, PB",
  "Maceió, AL",
  "Teresina, PI",
  "São Luís, MA",
  "Aracaju, SE",
  "Palmas, TO",
  "Uberlândia, MG",
  "Ribeirão Preto, SP",
  "Londrina, PR",
  "Joinville, SC",
  "Aparecida de Goiânia, GO",
  "Anápolis, GO",
  "Foz do Iguaçu, PR",
  "Santos, SP",
  "Maringá, PR"
];

export const destinations = [
  "Maldivas",
  "Paris, França",
  "Roma, Itália",
  "Tóquio, Japão",
  "Nova York, EUA",
  "Miami, EUA",
  "Orlando, EUA",
  "Los Angeles, EUA",
  "Londres, Inglaterra",
  "Barcelona, Espanha",
  "Madri, Espanha",
  "Lisboa, Portugal",
  "Porto, Portugal",
  "Amsterdã, Holanda",
  "Praga, República Tcheca",
  "Viena, Áustria",
  "Zurique, Suíça",
  "Santorini, Grécia",
  "Mykonos, Grécia",
  "Atenas, Grécia",
  "Dubai, Emirados Árabes",
  "Abu Dhabi, Emirados Árabes",
  "Cancún, México",
  "Punta Cana, República Dominicana",
  "Cartagena, Colômbia",
  "Buenos Aires, Argentina",
  "Santiago, Chile",
  "Patagônia, Argentina",
  "Bariloche, Argentina",
  "Machu Picchu, Peru",
  "Cusco, Peru",
  "Cairo, Egito",
  "Marrakech, Marrocos",
  "Cidade do Cabo, África do Sul",
  "Bali, Indonésia",
  "Bangkok, Tailândia",
  "Phuket, Tailândia",
  "Seul, Coreia do Sul",
  "Sydney, Austrália",
  "Queenstown, Nova Zelândia",
  "Havaí, EUA",
  "Bora Bora, Polinésia Francesa",
  "Fiji",
  "Seychelles",
  "Zanzibar, Tanzânia",
  "Fernando de Noronha, PE",
  "Gramado, RS",
  "Florianópolis, SC",
  "Jericoacoara, CE",
  "Lençóis Maranhenses, MA",
  "Bonito, MS",
  "Chapada dos Veadeiros, GO",
  "Porto de Galinhas, PE",
  "Trancoso, BA",
  "Arraial d'Ajuda, BA",
  "Búzios, RJ",
  "Paraty, RJ",
  "Ilhabela, SP",
  "Foz do Iguaçu, PR",
  "Manaus (Amazônia), AM",
  "Pantanal, MS",
  "Salvador, BA",
  "Costa do Sauípe, BA",
  "Praia do Forte, BA",
  "Morro de São Paulo, BA",
  "Natal, RN",
  "Pipa, RN",
  "São Miguel dos Milagres, AL",
  "Alter do Chão, PA",
  "Agra, Índia",
  "Auckland, Nova Zelândia",
  "Beijing, China",
  "Bogotá, Colômbia",
  "Bruxelas, Bélgica",
  "Delhi, Índia",
  "Doha, Catar",
  "Edimburgo, Escócia",
  "Hanoi, Vietnã",
  "Hong Kong, China",
  "Istambul, Turquia",
  "Jaipur, Índia",
  "Johannesburgo, África do Sul",
  "Kuala Lumpur, Malásia",
  "Lima, Peru",
  "Melbourne, Austrália",
  "Mumbai, Índia",
  "Nairóbi, Quênia",
  "New Delhi, Índia",
  "Osaka, Japão",
  "Reykjavík, Islândia",
  "San Francisco, EUA",
  "Singapura",
  "Taipei, Taiwan",
  "Vancouver, Canadá",
  "Victoria Falls, Zimbábue",
];
